import React, { useState, useEffect } from "react";
import * as Icon from "react-feather";
import {
  Button,
  Form,
  Input,
  Switch,
  Modal,
  Tabs,
  DatePicker,
  Space,
  Select,
} from "antd";
import { useDispatch } from "react-redux";
import activityService from "../../services/activity-service";
import appLoaderAction from "../../redux/action/app-loader-action";
import notifyUtitls from "../../utils/notify-utils";
import { UploadOutlined } from "@ant-design/icons";
import UploadImage from "../../components/upload/image";
import UploadFile from "../../components/upload/file";
import EditableTagGroup from "../../components/input/editable-tag-group";
import {
  fileTYPE_IMG,
  groupType,
  PREVIEW_TYPE,
} from "../../constants/app-constants";
import fileUtils from "../../utils/file-utils";
import HtmlEditor from "../../components/input/html-editor";
import moment from "moment";
import previewService from "../../services/preview-Service";

const { TabPane } = Tabs;

const defaultValue = {
  serviceActivityImage: null,
  serviceActivityFile: [],
  serviceActivityDate: null,
  isOpenNewTab: false,
  keywordList: [],
  urlSuffix: null,
};

const AddEditActivityDialog = ({
  isShow,
  onCancel,
  onSaveComplete,
  editData,
  renderGroupMenuOption,
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [serviceActivityImage, setServiceActivityImage] = useState(
    defaultValue.serviceActivityImage
  );
  const [serviceActivityFile, setServiceActivityFile] = useState(
    defaultValue.serviceActivityFile
  );
  const [serviceActivityDate, setServiceActivityDate] = useState(
    defaultValue.serviceActivityDate
  );
  const [keywordList, setKeywordList] = useState(defaultValue.keywordList);
  const [editorContentTH, setEditorContentTH] = useState("");
  const [editorContentEN, setEditorContentEN] = useState("");

  useEffect(() => {
    if (!isShow) {
      setServiceActivityImage(defaultValue.serviceActivityImage);
      setKeywordList(defaultValue.keywordList);
    }
  }, [isShow]);

  useEffect(() => {
    if (isShow && editData) {
      form.setFieldsValue({
        titleTH: editData.title.titleTH,
        titleEN: editData.title.titleEN,
        status: editData.status,
        totalView: editData.totalView,
        facebookLink: editData.facebookLink,
        groupMenuList: editData.groupMenuList ? editData.groupMenuList : [],
        urlSuffix: editData.urlSuffix,
      });
      setServiceActivityImage(editData.attachImage);
      setServiceActivityFile(editData.documentList);
      setServiceActivityDate(moment(editData.date));
      setKeywordList(
        editData.keywordList ? editData.keywordList : defaultValue.keywordList
      );
      setEditorContentTH(editData.content.contentTH);
      setEditorContentEN(editData.content.contentEN);
    } else {
      form.setFieldsValue({
        titleTH: null,
        titleEN: null,
        facebookLink: null,
        groupMenuList: [],
        urlSuffix: null,
      });
      setServiceActivityFile([]);
      setServiceActivityDate(null);
      setEditorContentTH("");
      setEditorContentEN("");
    }
  }, [isShow, editData]);

  const props = {
    action: "//jsonplaceholder.typicode.com/posts/",
    listType: "picture",
    multiple: false,
  };

  const onChangeValueTH = (value) => {
    setEditorContentTH(value);
  };

  const onChangeValueEN = (value) => {
    setEditorContentEN(value);
  };

  const onSave = async () => {
    try {
      const values = await form.validateFields();
      try {
        dispatch(appLoaderAction.enable());

        if (!editData) {
          let bean = {
            bean: {
              title: {
                titleTH: values.titleTH,
                titleEN: values.titleEN,
              },
              keywordList: keywordList,
              content: {
                contentTH: editorContentTH,
                contentEN: editorContentEN,
              },
              attachImage: serviceActivityImage,
              documentList: serviceActivityFile,
              date: serviceActivityDate,
              totalView: 0,
              status: values.status,
              facebookLink: values.facebookLink,
              groupMenuList: values.groupMenuList,
              urlSuffix: values.urlSuffix,
            },
          };

          await activityService.add(bean);
        } else {
          // let data = [];
          let bean = JSON.parse(JSON.stringify(editData));
          bean.title.titleTH = values.titleTH;
          bean.title.titleEN = values.titleEN;
          bean.content.contentTH = editorContentTH;
          bean.content.contentEN = editorContentEN;
          bean.keywordList = keywordList;
          bean.attachImage = serviceActivityImage;
          bean.status = values.status;
          bean.totalView = editData.totalView;
          bean.date = serviceActivityDate;
          bean.documentList = serviceActivityFile;
          bean.facebookLink = values.facebookLink;
          bean.groupMenuList = values.groupMenuList;
          bean.urlSuffix = values.urlSuffix;
          const editResult = {
            bean: {
              ...bean,
            },
          };

          await activityService.edit(editResult);
        }

        dispatch(appLoaderAction.disale());

        onSaveComplete();

        notifyUtitls.success("สำเร็จ", "บันทึกสำเร็จ");
      } catch (err) {
        notifyUtitls.error(err);
        dispatch(appLoaderAction.disale());
      }
    } catch (errorInfo) {
      notifyUtitls.warning("แจ้งเตือน", "โปรดระบุข้อมูลให้ครบถ้วน");
    }
  };

  const onTimeChange = (value, dateString) => {
    setServiceActivityDate(moment(value));
  };

  const onUploadTemp = ({ file }) => {
    if (file.status === "done") {
      const { bean } = file.response;
      setServiceActivityImage(bean);
    }
  };

  const onUploadFile = ({ file }) => {
    if (file.status === "done") {
      const { bean } = file.response;
      setServiceActivityFile([...serviceActivityFile, bean]);
    }
  };

  const onPreview = async () => {
    try {
      dispatch(appLoaderAction.enable());

      const values = await form.validateFields();
      let previewBean = JSON.parse(JSON.stringify(editData));

      previewBean.title = {
        titleTH: values.titleTH,
        titleEN: values.titleEN,
      };
      previewBean.content = {
        contentTH: editorContentTH,
        contentEN: editorContentEN,
      };

      previewBean.attachImage = serviceActivityImage;
      previewBean.date = serviceActivityDate;
      previewBean.documentList = serviceActivityFile;
      previewBean.facebookLink = values.facebookLink;
      previewBean.groupMenuList = values.groupMenuList;
      previewBean.urlSuffix = values.urlSuffix;

      const result = await previewService.savePreview({
        preview: { content: PREVIEW_TYPE.activity, bean: previewBean },
      });

      setTimeout(() => {
        dispatch(appLoaderAction.disale());
        window.open(
          `${process.env.REACT_APP_PREVIEW_ENDPOINT}/activity/${
            previewBean.urlSuffix
              ? previewBean.urlSuffix
              : previewBean.activityId
              ? previewBean.activityId
              : result.token
            // previewBean.activityId ? previewBean.activityId : result.token
          }/?token=${result.token}`,
          "winname",
          "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no"
        );
      }, 500);
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  return (
    <div className="container h-100">
      <div className="title-page">
        <Modal
          title={editData ? "แก้ไขกิจกรรม" : "เพิ่มกิจกรรม"}
          centered
          width={750}
          visible={isShow}
          onCancel={onCancel}
          destroyOnClose
          footer={[
            <Button key="submit" type="primary" onClick={onSave}>
              <Icon.Save className="me-2" size={17} />
              บันทึก
            </Button>,
            <Button key="back" className="btn-gray" onClick={onCancel}>
              ยกเลิก
            </Button>,
            <Button className="mx-2 btn-line" onClick={() => onPreview()}>
              <Icon.Eye className="me-1" size={18} /> ดูตัวอย่างเว็บไซต์
            </Button>,
          ]}
        >
          <Form
            layout="vertical"
            name="add_edit_user"
            preserve={false}
            form={form}
            initialValues={{
              status: true,
            }}
            validateMessages={{
              required: "โปรดระบุ",
            }}
          >
            <Tabs defaultActiveKey="1">
              <TabPane tab="Thai" key="1">
                <Form.Item
                  label="ชื่อกิจกรรม"
                  name="titleTH"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="เนื้อหากิจกรรม"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <div>
                    <HtmlEditor
                      key="th"
                      id="th"
                      setContents={editorContentTH}
                      onChange={onChangeValueTH}
                    />
                  </div>
                </Form.Item>
              </TabPane>
              <TabPane tab="English" key="2">
                <Form.Item label="Title" name="titleEN" className="mb-4">
                  <Input />
                </Form.Item>
                <Form.Item label="Content" className="mb-4">
                  <HtmlEditor
                    key="en"
                    id="en"
                    setContents={editorContentEN}
                    onChange={onChangeValueEN}
                  />
                </Form.Item>
              </TabPane>
            </Tabs>

            <Form.Item
              label="วันที่จัดกิจกรรม"
              name="serviceActivityDate"
              rules={[
                {
                  required: serviceActivityDate ? false : true,
                },
              ]}
            >
              <Space direction="vertical" size={12}>
                <DatePicker
                  showTime
                  onChange={onTimeChange}
                  defaultValue={serviceActivityDate}
                  format="DD MMMM YYYY hh:mm:ss"
                />
              </Space>
            </Form.Item>

            <Form.Item label="เอกสารแนบ" name="fileHeader">
              <UploadFile
                {...props}
                onChange={onUploadFile}
                fileList={serviceActivityFile}
              >
                <Button type="dashed" icon={<UploadOutlined />}>
                  Upload File
                </Button>
              </UploadFile>
              {/* {serviceActivityFile ? (
                                serviceActivityFile.map((file) => {
                                    return (
                                        <div>
                                            <a href={
                                                fileUtils.getFileRenderUrl(
                                                    groupType.ACTIVITY,
                                                    editData ? editData.activityId : null,
                                                    file.originalFilename
                                                )} download>
                                                {file.originalFilename}
                                            </a>
                                        </div>
                                    )
                                })
                            ) : 'อัปโหลดไฟล์'} */}
            </Form.Item>

            <Form.Item
              label="รูปภาพ"
              valuePropName="photoList"
              name="imageHeader"
              rules={[
                {
                  required: serviceActivityImage ? false : true,
                },
              ]}
            >
              <UploadImage
                listType="picture-card"
                accept={fileTYPE_IMG}
                showUploadList={false}
                onChange={onUploadTemp}
                className={serviceActivityImage ? "view-upload" : null}
                // limitWidth={1900}
                // limitHeight={710}
              >
                {serviceActivityImage ? (
                  <img
                    src={
                      serviceActivityImage.tempFilename
                        ? fileUtils.getTempFileRenderUrl(
                            serviceActivityImage.tempFilename,
                            serviceActivityImage.type
                          )
                        : fileUtils.getFileRenderUrl(
                            groupType.ACTIVITY,
                            editData ? editData.activityId : null,
                            serviceActivityImage.originalFilename
                          )
                    }
                    alt="avatar"
                    style={{ width: "100%" }}
                  />
                ) : (
                  "อัปโหลดไฟล์"
                )}
              </UploadImage>
              <label className="text-danger">
                * ขนาดรูปภาพที่แนะนำคือ 1900x710 pixels.
              </label>
            </Form.Item>

            <Form.Item label="คีย์เวิร์ด">
              <EditableTagGroup onChange={setKeywordList} tags={keywordList} />
            </Form.Item>

            <Form.Item label="FacebookLink" name="facebookLink">
              <Input />
            </Form.Item>

            <Form.Item
              label="URL Name"
              name="urlSuffix"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item label="สถานะ" name="status" valuePropName="checked">
              <Switch />
            </Form.Item>

            <Form.Item
              label="กลุ่มผู้ใช้งาน"
              name="groupMenuList"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select customWidth="100%" mode="multiple" showArrow>
                {renderGroupMenuOption()}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default AddEditActivityDialog;
